module.exports = __webpack_public_path__ + "static/media/pensionnara_logo.58e0a796.png";